module.exports = __webpack_public_path__ + "static/img-shipping-containers@2x.da0c2ab1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/img-shipping-containers@2x.jpg
// module id = 801
// module chunks = 222764574844450